import handlebars from "handlebars";

handlebars.registerHelper("increment", function (value) {
    return parseInt(value) + 1;
});

handlebars.registerHelper("for", function (from, to, incr, block) {
    var accum = "";
    for (var i = from; i < to; i += incr) accum += block.fn(i);
    return accum;
});

handlebars.registerHelper("ifCond", function (v1, v2, options) {
    if (v1 === v2) {
        return options.fn(this);
    }
    return options.inverse(this);
});

handlebars.registerHelper("eq", function (v1, v2) {
    return v1 === v2;
});

handlebars.registerHelper("defined", function (value) {
    return value !== null && value !== undefined;
});

handlebars.registerHelper("spaceToBr", function (text) {
    if (typeof text !== "string") return text;
    // Replace each space with a <br> tag and mark as safe.
    const replaced = text.replace(/ /g, "<br>");
    return new handlebars.SafeString(replaced);
});

handlebars.registerHelper("rarityClass", function (key) {
    if (typeof key !== "string") return "";

    const rarityMap = {
        lv1: "card-collection__filter-option-label--bronze",
        lv2: "card-collection__filter-option-label--silver",
        lv3: "card-collection__filter-option-label--gold",
        lv4: "card-collection__filter-option-label--diamond",
        lv5: "card-collection__filter-option-label--legendary",
    };

    return rarityMap[key] || "";
});

/**
 * Returns the select-colleague card rarity modifier class, or empty string if no rarity.
 * Used to avoid {{#if}} block inside class attribute (Handlebars parse error).
 */
handlebars.registerHelper(
    "selectColleagueCardRarityClass",
    function (rarityLevel) {
        return rarityLevel ? "select-colleague__card--" + rarityLevel : "";
    },
);

/**
 * Generate WordPress-style pagination data.
 * Returns object with pagination state for WordPress-style pagination UI.
 */
handlebars.registerHelper("paginationData", function (pagination) {
    if (!pagination || !pagination.total_pages || pagination.total_pages <= 0) {
        return {
            currentPage: 1,
            totalPages: 1,
            showFirst: false,
            showPrev: false,
            showNext: false,
            showLast: false,
        };
    }

    const currentPage = parseInt(pagination.current_page) || 1;
    const totalPages = parseInt(pagination.total_pages) || 1;

    return {
        currentPage: currentPage,
        totalPages: totalPages,
        showFirst: currentPage > 1,
        showPrev: currentPage > 1,
        showNext: currentPage < totalPages,
        showLast: currentPage < totalPages,
    };
});

const compile = (htmlTemplate, data) => {
    const template = handlebars.compile(htmlTemplate);
    return template(data);
};

export default compile;
